import React, { Component } from "react";
import config from "lib/fr-config";
import TextButtonView from "presentational/common/TextButtonView";
import IconButtonView from "presentational/common/IconButtonView";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

const colorCss = config.css.color;

const css = {
  root: { display: "flex", alignItems: "center" },
  btnTextWrapper: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    whiteSpace: "normal"
  },
  colon: { padding: "0 5px" },
  secondaryText: {
    color: colorCss.colorOfPrimary,
    textAlign: "right"
  },
  requiredBadge: {
    display: "inline-flex",
    alignItems: "center",
    height: 20,
    padding: "0 7px",
    borderRadius: 999,
    background: colorCss.colorOfBadge,
    color: colorCss.colorOfPrimary,
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "-0.03em",
    lineHeight: 1
  }
};

class ColonTextButtonView extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    primary: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    secondary: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    disableLeftMargin: PropTypes.bool,
    disableRightMargin: PropTypes.bool,
    onClear: PropTypes.func,
    showClearButton: PropTypes.bool,
    showRequiredBadge: PropTypes.bool,
    hidePrimary: PropTypes.bool
  };

  static defaultProps = {
    secondary: null,
    disableLeftMargin: false,
    disableRightMargin: false,
    onClear: () => {},
    showClearButton: false,
    showRequiredBadge: false,
    hidePrimary: false
  };

  render() {
    const {
      onClick,
      primary,
      secondary,
      disableLeftMargin,
      disableRightMargin,
      onClear,
      showClearButton,
      showRequiredBadge,
      hidePrimary
    } = this.props;
    return (
      <div style={css.root}>
        {showRequiredBadge && !secondary && (
          <span style={css.requiredBadge}>
            <TXT name="wordBadge_requiredInfo" />
          </span>
        )}
        {showClearButton && (
          <IconButtonView
            type={"close"}
            onClick={onClear}
            fontSize={"small"}
            buttonSize={"small"}
          />
        )}
        <TextButtonView
          disableLeftMargin={disableLeftMargin}
          disableRightMargin={disableRightMargin}
          onClick={onClick}
        >
          <span style={css.btnTextWrapper}>
            {!hidePrimary && <span>{primary}</span>}
            {!hidePrimary && secondary && <span style={css.colon}>:</span>}
            {secondary && <span style={css.secondaryText}>{secondary}</span>}
          </span>
        </TextButtonView>
      </div>
    );
  }
}

export default ColonTextButtonView;
